
export default {
  props: {
    testimonial: {
      type: Object,
      required: true,
    },
  },
};
